import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5em;
  width: 100%;
  margin-bottom: 1.5em;
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const DateRangeField = styled.div`
  width: 100%;

  @media ${({ theme }) => theme.queries.minTablet} {
    max-width: 320px;
  }
`;
